import "./ActionButtons.css";

import changePassword from "../../images/profile/profile_change_password.svg"
import logout from "../../images/profile/profile_logout.svg"
import { ChevronRight } from "lucide-react";

export default function ActionButtons({
    onPasswordClick,
    onLogoutClick,
}) {
    return (
        <div className="security-actions">

            <button
                className="security-item"
                onClick={onPasswordClick}
            >
                <div className="security-item-left">
                    <img
                        src={changePassword}
                        alt=""
                        className="security-icon"
                    />

                    <span>Alterar palavra-passe</span>
                </div>
                <ChevronRight size={22} color="#444" />
            </button>

            <button
                className="security-item"
                onClick={onLogoutClick}
            >
                <div className="security-item-left">
                    <img
                        src={logout}
                        alt=""
                        className="security-icon"
                    />

                    <span>Logout</span>
                </div>
                <ChevronRight size={22} color="#444" />
            </button>

        </div>
    );
}